'use client';

import PrimaryButton from '@/components/ui/Button/PrimaryButton';
import {
  ExpandableCardGrid,
  type ExpandableCardItem,
} from '@/components/ui/ExpandableCard';
import RichText from '@/components/ui/RichText/RichText';
import SectionGrid from '@/components/ui/SectionGrid/SectionGrid';
import type { TextBlock } from '@/types/pageContentTypes';

export interface ExpandableCardsSectionData {
  cards: {
    iconUrl?: string;
    title: TextBlock;
    description: TextBlock;
  }[];
  btnText: string;
}

interface ExpandableCardsSectionProps {
  data: ExpandableCardsSectionData;
  desktopColumns?: 2 | 3;
  spacingClassName: string;
}

export default function ExpandableCardsSection({
  data,
  desktopColumns = 3,
  spacingClassName = 'py-8 md:py-10',
}: ExpandableCardsSectionProps) {
  if (!data) return null;

  const { cards, btnText } = data;
  const cardItems: ExpandableCardItem[] = cards.map((card, index) => ({
    id: String(index),
    iconUrl: card.iconUrl,
    title: <RichText styles={card.title.styles}>{card.title.content}</RichText>,
    description: (
      <RichText styles={card.description.styles}>
        {card.description.content}
      </RichText>
    ),
  }));

  return (
    <SectionGrid
      gridClassName="grid-cols-1"
      spacingClassName={spacingClassName}
    >
      <ExpandableCardGrid
        cards={cardItems}
        clampLines={{ base: 10, md: 10, xl: 6 }}
        columns={{ base: 1, md: 2, xl: desktopColumns }}
        maxCollapsedHeight={{ base: 360, md: 380, xl: 380 }}
      />

      <div
        className="my-8 flex w-full justify-center md:my-10"
        data-hide-floating-actions="true"
      >
        <PrimaryButton
          data={{ title: btnText, functionality: 'book_appointment' }}
          className="w-fit text-base! font-bold"
          widthFitContent
        />
      </div>
    </SectionGrid>
  );
}
